import React from "react";
import { ArApWriteOffsDetail } from "../../../components/Pages/Documents/ArApWriteOffs/ArApWriteOffsDetail";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { CreateArapWriteOffsDto } from "../../../dtos/documents/ArApWriteOffs/CreateArApWriteOffsDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ArApWriteOffsService } from "../../../services/documents/ArApWriteOffsService";
import { NFLookupArapWriteOffs } from "../../../components/Shared/NewForms/NFLookupArapWriteOffs";

import ArApWriteOffsList from "../../../components/Pages/Documents/ArApWriteOffs/ArApWriteOffsList";

export const ArApWriteOffs: IAppEntity = {
  entityType: "document",
  title: "ArAp Write Offs",
  pluralTitle: "ArApWriteOffs",
  apiUrl: "ArApWriteOffs",
  apiEnum: ReferenceTypes.DocumentArApWriteOff,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ArApWriteOffsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ArApWriteOffsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupArapWriteOffs, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ArApWriteOffsService("ArApWriteOffs"),
  getEmptyModel: () => {
    const model: CreateArapWriteOffsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      documentNumber: "",
      status: 0,
      
    };
    return model;
  },
};
